module.exports = __webpack_public_path__ + "img/teamwork-icon-7.5b1f57ba.png";